/* eslint-disable no-unused-vars */
/* global React */
import CellHOC from '@platform/react/hoc/list/cell'
import { useCallback, useEffect, useRef, useState } from 'react'
import Autocomplete from 'ui/Element/Field/Autocomplete'
import PlatformEvent from 'lib/util/event'
import { getFirstItem } from 'lib/util'
import { useMemoRef } from 'platform/react/hook'

/**
 * Returns the ListItemCellUserAdminRoleAtOrg element's current theme styles.
 *
 * @param {Object} theme    the application's current theme
 * @returns {Object}        the ListItemCellUserAdminRoleAtOrg component's styles
 */
const styles = theme => ({
  root: {
    width: '100%',
    marginRight: '0.3125rem',
  },
})

/**
 * Displays the atOrganisation input field for each users' role.
 *
 * @param {Object} classes  styling for the cell
 * @param {Object} props    props for the cell
 *
 * @returns {*}
 */
export const ListItemCellUserAdminRoleAtOrg = (classes, props = {}) => {
  const { index, label, atOrg, events, view, delete: isDeleted } = props
  const parentRef = useRef(null)
  const [currentOrganisation, setCurrentOrganisation] = useState(null)

  useEffect(() => {
    (async () => {
      const event = new CustomEvent('create')
      const result = await events?.onAtOrgCreate(new PlatformEvent(event, { value: atOrg, index }))
      const organisation = getFirstItem(result) || {}

      const newCurrentOrganisation = currentOrganisation?.key !== organisation.key
        || currentOrganisation?.disabled !== organisation.disabled
        ? organisation
        : currentOrganisation

      setCurrentOrganisation(newCurrentOrganisation)
    })()
  }, [atOrg])

  const handleChange = useCallback((e) => {
    const changeEvent = new PlatformEvent(e, { ...e.detail, index })
    events?.onAtOrgChange(changeEvent)
  }, [events?.onAtOrgChange])

  const Field = React.forwardRef(Autocomplete)

  return (
    <Field
      events={{
        onOpen: events?.onAtOrgOpen,
        onChange: handleChange,
        getLabel: events?.getLabel,
        onLinkChange: events?.onLinkChange,
      }}
      ref={parentRef}
      view={view}
      className={classes.input}
      label={label}
      value={currentOrganisation}
      freeText={true}
      // error={true}
      required={true}
      oneShot={true}
      // debounced={500}
      disabled={isDeleted}
      clearable={false}
      openInNewTab={true}
      valueOf={() => false} />
  )
}

export default useMemoRef(CellHOC(ListItemCellUserAdminRoleAtOrg, styles), props => [props.atOrg, props.delete])
